<template>
  <div class="newGame">
    <GameList :gameList="gameList" type='game' />
  </div>
</template>
<script>
import GameList from "@/components/gameList.vue";
export default {
  name: "newGame",
  components: {GameList},
  props:['list'],
  data() {
    return {
      gameList:[]
    };
  },
  created() {},
  mounted() {
    this.gameList=this.list;
  },
  methods: {
  },
};
</script>
<style lang="scss" scoped>
@mixin flex_box(
  $flex-direction: row,
  $justify-content: none,
  $align-items: none
) {
  display: flex;
  flex-direction: $flex-direction;
  justify-content: $justify-content;
  align-items: $align-items;
}
.newGame {
  width:7.5rem;
  @include flex_box(column, none, stretch);
  // padding: 0 0.16rem;
  box-sizing: border-box;

  .li {
    @include flex_box(column, none, stretch);
    border-bottom: 1px solid #e7e7e7;
  }
  .top {
    @include flex_box(row, space-between, center);
    height: 1.38rem;
    min-height: 1.38rem;
  }
  .li_icon {
    width: 1.08rem;
    height: 1.08rem;
  }
  .li_middle {
    flex: 1;
    margin: 0 0.2rem;
    @include flex_box(column, center, flex-start);
  }
  .li_middle_top {
    @include flex_box(row, center, center);
    font-size: 14px;
  }
  .li_title {
    color: #656565;
  }
  .li_gift_text {
    position: relative;
    margin-left: 0.1rem;
    color: #ff913a;
  }
  .li_gift {
    position: absolute;
    top: 0;
    right: -0.6rem;
    @include flex_box(row, center, center);
    width: 0.5rem;
    height: 0.26rem;
    background-color: #3aa2f2;
    border-radius: 2px;
    font-size: 12px;
    color: #fff;
    span {
      transform: scale(0.7);
      transform-origin: center center;
      line-height: 0.26rem;
    }
  }
  .li_small_title {
    margin-top: 0.1rem;
    font-size: 12px;
    color: #999999;
    transform: scale(0.8);
    transform-origin: 0 center;
    width: 120%;
    text-align: left;
  }
  .li_right {
    @include flex_box(row, center, center);
    width: 1rem;
    height: 0.46rem;
    background-color: #ff913a;
    border-radius: 4px;
    color: #fff;
    font-size: 12px;
  }

  .bot {
    width: 100%;
    @include flex_box(row, flex-start, center);
    overflow-x: scroll;
    margin-bottom: .2rem;
  }
  .bot_item {
    width: 1.88rem;
    margin-right: 0.16rem;
    img {
      width: 1.88rem;
      height: auto;
      vertical-align: text-top;
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/components/newGame.vue